import axios from 'axios';
import authHeader from "@/service/auth-header";

class SupplierService {

    getCompanySuppliers(companyId) {
        return axios.get(`/api/supplier/${companyId}`, {headers: authHeader()})
    }

    getSupplier(supplierId) {
        return axios.get(`/api/supplier/specific/${supplierId}`, {headers: authHeader()})
    }

    createSupplier(companyId, data) {
        return axios.post(`/api/supplier/${companyId}`, data, {headers: authHeader()});
    }

    updateSupplier(supplierId, data) {
        return axios.put(`/api/supplier/${supplierId}`, data, {headers: authHeader()});
    }

    deleteSupplier(supplierId) {
        return axios.delete(`/api/supplier/${supplierId}`, {headers: authHeader()})
    }

}

export default new SupplierService();
